import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';

import { Container, PercentageBar, ValueButton } from './styles';
import { useRange } from '@spa/shared/hooks/range';

export const Range = ({ min, max, valueMin, valueMax, onChange, step = 1 }) => {
  const ref = useRef();
  const { t } = useTranslation();
  const { first, second, minFactor, maxFactor } = useRange(ref, min, max, [valueMin, valueMax], onChange, step);

  return (
    <Container ref={ref}>
      <PercentageBar
        style={{
          width: `${(maxFactor - minFactor) * 100}%`,
          left: `${minFactor * 100}%`,
          right: `${(1 - maxFactor) * 100}%`
        }}
      />
      <ValueButton
        aria-label={t('aria.range.min_value')}
        role="slider"
        aria-valuemax={max}
        aria-valuemin={min}
        aria-valuenow={valueMin}
        {...first.onDrag()}
        dragPosition={first.dragPosition}
      />
      <ValueButton
        aria-label={t('aria.range.max_value')}
        tabIndex="0"
        role="slider"
        aria-valuemax={max}
        aria-valuemin={min}
        aria-valuenow={valueMax}
        {...second.onDrag()}
        dragPosition={second.dragPosition}
      />
    </Container>
  );
};

Range.propTypes = {
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  valueMin: PropTypes.number.isRequired,
  valueMax: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  step: PropTypes.number
};
